import { format } from "date-fns";
import _ from "lodash";

export const dateToString = (date: Date) => {
  try {
    return format(date, "yyyy-MM-dd");
  } catch {
    return "Invalid date";
  }
};

// TODO: Figure out what to do with bad string data for these functions
export function parseIntDate(str: string): Date {
  return new Date(parseInt(str));
}

export function dateToIntString(date: Date): string {
  return String(date.getTime());
}

export function parseIntSecondsTimeMilliseconds(str: string): number {
  return parseInt(str) * 1000;
}

export function parseDateStringToMilliseconds(str: string): number {
  return new Date(str).getTime();
}

export function parseIntTimeMilliseconds(str: string): number {
  return parseInt(str);
}

export function parseIntSecondsDate(str: string): Date {
  return new Date(parseInt(str) * 1000);
}

export function parseIntMillisecondsDate(str: string): Date {
  return new Date(parseInt(str));
}

export function dateToIntSecondsString(date: Date): string {
  return String(Math.round(date.getTime() / 1000));
}

export function isValidDate(date: Date | null | undefined): boolean {
  return !_.isNil(date) && !_.isNaN(date.getTime());
}
